var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center py-4"},[_c('v-btn',{attrs:{"text":"","elevation":"0"},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v(" Cancel")]),_c('v-btn',{staticClass:"ml-2",attrs:{"color":"#E7A24D","elevation":"0"},on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }